import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SessaoContext } from "../Contexts/SessaoContext";

/**
 * Redireciona o usuário para algum lugar. O redirecionamento é cancelado se o usuário possui ao menos uma das permissões inclusas no array. <br/>
 * Por padrão, o usuário é redirecionado para a home.
 */
export const useRedirection = (aoMenosUmaDasPermissoes: string[], para: string = "/") => {
    const permissoes = useContext(SessaoContext)?.sessao?.usuario?.permissoes.map((p) => p.nome);
    const navigate = useNavigate();

    useEffect(() => {
        if(permissoes == undefined) return;

        if(aoMenosUmaDasPermissoes.every((p) => !permissoes.includes(p))){
            navigate(para);
        } 

    }, [permissoes])

}